// extracted by mini-css-extract-plugin
export default {"imageContainer":"O0-z","summaryPar":"P0-z","ratingCategories":"Q0-z","reviewerInfo":"R0-z","reviewTypes":"S0-z","expanded":"T0-z"};